/** Типы фоновых Excel-задач mongo_master для импорта/экспорта. */
export type ExcelTaskType = 'articles' | 'change_log' | 'plan_and_fact'

/** Ключ localStorage для вкладки «Массовые операции» на странице настроек. */
export const BULK_OPERATIONS_TAB_STORAGE_KEY = 'settings_bulk_operations_tab'

const EXCEL_TASK_TYPE_SET = new Set<string>(['articles', 'change_log', 'plan_and_fact'])

/** Проверяет, что значение — допустимый тип Excel-задачи. */
export function isExcelTaskType(value: unknown): value is ExcelTaskType {
  return typeof value === 'string' && EXCEL_TASK_TYPE_SET.has(value)
}

/** Значения Redis-ключа task:type:{task_id}, которые выставляет backend. */
export const REDIS_EXCEL_TASK_TYPES = {
  articles_export: 'articles',
  articles_import: 'articles',
  change_log_export: 'change_log',
  change_log_import: 'change_log',
  plan_and_fact_export: 'plan_and_fact',
  plan_and_fact_import: 'plan_and_fact',
} as const satisfies Record<string, ExcelTaskType>

export type RedisExcelTaskType = keyof typeof REDIS_EXCEL_TASK_TYPES

/** Ключ localStorage для сохранения кнопки «Скачать» после экспорта. */
export function getExportedFileStorageKey(shopId: string, type: ExcelTaskType): string {
  if (type === 'change_log') {
    return `change_log_exported_file_${shopId}`
  }
  if (type === 'plan_and_fact') {
    return `plan_and_fact_exported_file_${shopId}`
  }
  return `article_manage_exported_file_${shopId}`
}

/** Преобразует task:type из Redis в ExcelTaskType. Без эвристик — только явный маппинг. */
export function parseExcelTaskType(redisTaskType: string | undefined | null): ExcelTaskType | null {
  if (!redisTaskType) {
    return null
  }
  return REDIS_EXCEL_TASK_TYPES[redisTaskType as RedisExcelTaskType] ?? null
}

/** Человекочитаемая подпись типа задачи для toast-уведомлений. */
export function getExcelTaskLabel(taskType: ExcelTaskType): string {
  if (taskType === 'change_log') {
    return 'журнала изменений'
  }
  if (taskType === 'plan_and_fact') {
    return 'плана/факта'
  }
  return 'артикулов'
}

/** Название блока массовой операции в интерфейсе настроек магазина. */
export function getExcelBulkOperationTitle(taskType: ExcelTaskType): string {
  if (taskType === 'change_log') {
    return 'Журнал изменений'
  }
  if (taskType === 'plan_and_fact') {
    return 'План/факт'
  }
  return 'Артикулы'
}
